const mod = require('../../bahabot.module.js')

mod.directive('bbInvalidIf', [function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            scope.$watch(attrs.bbInvalidIf, function (invalidState) {
                if (!invalidState) return;

                if (angular.isObject(invalidState)) {
                    for (const key in invalidState) {
                        ctrl.$setValidity(key, !invalidState[key]);
                    }
                } else {
                    ctrl.$setValidity('bbInvalidIf', !invalidState);
                }
            }, true);
        }
    };
}]);